import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
// Tailwind css
import './tailwind.css';

// i18n (needs to be bundled)
import './i18n';

// Router
import { RouterProvider } from 'react-router-dom';
import router from './router/index';

// AXIOS (AXIOS & INTERCEPTORS)
import './lib/axios/axios-global';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <Suspense>
        <RouterProvider router={router} />
    </Suspense>,
);
